import { Component } from "react";
import styles from "./jetpass-name-selection.module.less";
import SiteConfigurationStore from "components/stores/site-configuration-store";
import { FormBuilder, GhostButton, PrimaryButton, buildField, getInitialForm } from "@parksandresorts/core";
import InputField from "components/forms/input-field/input-field";
import { motion } from "polyfill/motion-polyfill/motion-polyfill";
import { extract } from "@parksandresorts/core";

class JetPassNameSelection extends Component {
  constructor(props) {
    super(props);

    this.submitNames = this.submitNames.bind(this);

    this.namingHeadline = SiteConfigurationStore.getLabel(
      "JETPASS_NAMING_HEADLINE",
      "Namnge de olika åkarna för att boka individuella åkpass",
    );

    this.guestNameFormUtilities = FormBuilder("guestNamesForm", this);

    const guestNamesForm = getInitialForm();
    for (let i = 0; i < props.numberOfGuests; i++) {
      const keyName = "guest_" + i;
      guestNamesForm.fields.set(keyName, buildField(keyName, { isRequired: false, value: "" }));
    }

    this.state = {
      guestNamesForm: guestNamesForm,
    };
  }

  submitNames() {
    const namesAsArray = Array.from(this.state.guestNamesForm.fields.values()).map((field) => field.value);
    this.props.onSubmitNames(namesAsArray);
  }

  render() {
    return (
      <motion.div initial={{ x: -40, opacity: 0 }} animate={{ x: 0, opacity: 1 }} className={styles.wrapper}>
        <div className="block--max-width-narrow">
          <h3 className={styles.headline}>{this.namingHeadline}</h3>
          <div className={styles.formWrapper}>
            {Array.from(this.state.guestNamesForm.fields.values()).map((field, index) => {
              const productName = extract(this.props, `guests[${index}].productInfo.productName`, null);
              return (
                <InputField
                  key={index}
                  placeholder="Skriv in namnet på gästen"
                  label={"Gäst " + (index + 1)}
                  additionalText={productName}
                  maxLength={15}
                  formField={field}
                  onChange={this.guestNameFormUtilities.handleFieldOnChange}
                />
              );
            })}
          </div>
          <div className={styles.buttonWrapper}>
            <PrimaryButton label="Fortsätt" className={styles.continueButton} onClick={this.submitNames} />
            <GhostButton label="Hoppa över" className={styles.optOutButton} onClick={this.props.onCancelSubmitNames} />
          </div>
        </div>
      </motion.div>
    );
  }
}

export default JetPassNameSelection;
